import React, {useContext} from "react";
import "./SplashScreen.css";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import {greeting, splashScreen} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import { Typewriter } from 'react-simple-typewriter'

export default function SplashScreen() {
  const {isDark} = useContext(StyleContext);
  return (
    <div className={isDark ? "dark-mode splash-container" : "splash-container"}>
      <div className="splash-animation-container">
        <DisplayLottie animationData={splashScreen.animation} style={{ filter: "brightness(0) saturate(100%) invert(100%)" }}
        />
      </div>
      <div className="splash-title-container">
        <span className="splash-title">
          <Typewriter
            words={[greeting.username]}
            typeSpeed={125}
            deleteSpeed={0}
            delaySpeed={0}
            loop={1}
            cursor
            cursorStyle="|"
          />
        </span>
      </div>
    </div>
  );
}
